var map = {
	"./about-us.svg": 765,
	"./betting-icon.svg": 766,
	"./bonus.svg": 767,
	"./coin.png": 768,
	"./contact-us.svg": 769,
	"./download-app.svg": 770,
	"./edit-btn.svg": 771,
	"./feedback.svg": 772,
	"./global.svg": 773,
	"./info-centre.svg": 774,
	"./instant-rebate.svg": 775,
	"./mall-icon.svg": 776,
	"./message.svg": 777,
	"./redemption-icon.svg": 778,
	"./referral.svg": 779,
	"./resp-gaming.svg": 780,
	"./security.svg": 781,
	"./transaction-icon.svg": 782,
	"./vip-icon.svg": 783,
	"./wallet-icon.svg": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;